export const FlameIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g>
        <path d="M12.3593 19.1667C16.6667 17.3333 20.9741 10.3056 8.05189 0.833344C7.12888 7.86112 -1.48594 13.6667 7.12888 19.1667C6.30844 18.7592 5.28284 16.4167 5.89819 14.5833C6.61611 12.4445 6.8212 11.8333 6.51353 10.6111C7.33397 10.9167 8.97491 11.4667 8.97491 13.6667C10.103 12.75 11.1286 11.2222 10.2056 8.47223C12.2567 10.1019 15.8052 13.0556 12.3593 19.1667Z" />
      </g>
    </svg>
  );
};
